module.exports = __webpack_public_path__ + "static/media/doneIcon.87bf0e18.gif";